var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 0,
    height: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "archive"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 5,
    x: 2,
    y: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12h4"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "arrow-right-left"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 3 4 4-4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 7H4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 21-4-4 4-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 17h16"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 5 7 7-7 7"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5 12 7-7 7 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19V5"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "bell"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.268 21a2 2 0 0 0 3.464 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "book-user"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 13a3 3 0 1 0-6 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 2
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "bot-message-square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6V2H8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 18-4 4V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12h2"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "briefcase-business"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 13a18.15 18.15 0 0 1-20 0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    x: 2,
    y: 6,
    rx: 2
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "building-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18h4"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "building"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    x: 4,
    y: 2,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22v-4h6v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14h.01"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "bus-front"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 6 2 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 7-2-1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 4,
    y: 3,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 19v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 21v-2"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "cake"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 21h20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 8v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 4h.01"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "calendar-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 14h1v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 2v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2v4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 18,
    rx: 2
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "calendar-days"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 2v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 2v4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18h.01"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "check"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 6 9 17l-5-5"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 9 6 6 6-6"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "chevron-left"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15 18-6-6 6-6"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9 18 6-6-6-6"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "chevrons-left"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11 17-5-5 5-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 17-5-5 5-5"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "chevrons-right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 17 5-5-5-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 17 5-5-5-5"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "circle-alert"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    x2: 12,
    y1: 8,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    x2: 12.01,
    y1: 16,
    y2: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "circle-check-big"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.801 10A10 10 0 1 1 17 3.335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 11 3 3L22 4"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "circle-check"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 12 2 2 4-4"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "circle-dollar-sign"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18V6"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "circle-help"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17h.01"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "circle-plus"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8v8"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "circle-user"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "circle-x"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 9-6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 9 6 6"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "clock"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 6 12 12 16 14"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "cloud-alert"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18h.5a1 1 0 0 0 0-9h-1.79A7 7 0 1 0 7 17.708"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "coins"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.09 10.37A6 6 0 1 1 10.34 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6h1v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.71 13.88.7.71-2.82 2.82"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "copy"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 8,
    y: 8,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "credit-card"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    x: 2,
    y: 5,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    x2: 22,
    y1: 10,
    y2: 10
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "crown"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21h14"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "dollar-sign"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12,
    x2: 12,
    y1: 2,
    y2: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "download"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 10 12 15 17 10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    x2: 12,
    y1: 15,
    y2: 3
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "ellipsis-vertical"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 1
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "eye-off"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.084 14.158a3 3 0 0 1-4.242-4.242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 2 20 20"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "eye"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "factory"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18h1"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "file-chart-column-increasing"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2v4a2 2 0 0 0 2 2h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18v-6"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "file-chart-line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2v4a2 2 0 0 0 2 2h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 13-3.5 3.5-2-2L8 17"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "file-chart-pie"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2v4a2 2 0 0 0 2 2h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.017 11.512a6 6 0 1 0 8.466 8.475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16a1 1 0 0 1-1-1v-4c0-.552.45-1.008.995-.917a6 6 0 0 1 4.922 4.922c.091.544-.365.995-.917.995z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "file-cog"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2v4a2 2 0 0 0 2 2h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.2 12.9-.9-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.2 15.1-.9.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.677 21.5a2 2 0 0 0 1.313.5H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.9 11.2-.4-.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.9 16.8-.4.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 10.3-.4.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 17.7-.4-.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.7 12.5-.9.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.7 15.5-.9-.4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 14,
    r: 3
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "file-diff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13V7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17h6"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "file-down"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2v4a2 2 0 0 0 2 2h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18v-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 15 3 3 3-3"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "file-pen-line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18h1"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "file-plus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2v4a2 2 0 0 0 2 2h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18v-6"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "file-spreadsheet"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2v4a2 2 0 0 0 2 2h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 17h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 17h2"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "file-stack"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 7h-3a2 2 0 0 1-2-2V2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6v6.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5v-9c0-.8.7-1.5 1.5-1.5H17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H11"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "file"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2v4a2 2 0 0 0 2 2h4"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "filter"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "flag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 4,
    y1: 22,
    y2: 15
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "folder-open"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "footprints"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13h4"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "gold-crown"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.562 3.266C11.6052 3.18761 11.6686 3.12223 11.7456 3.0767C11.8227 3.03117 11.9105 3.00716 12 3.00716C12.0895 3.00716 12.1773 3.03117 12.2544 3.0767C12.3314 3.12223 12.3948 3.18761 12.438 3.266L15.39 8.87C15.4604 8.99976 15.5586 9.11233 15.6777 9.19962C15.7968 9.28691 15.9337 9.34675 16.0786 9.37486C16.2235 9.40297 16.3729 9.39863 16.5159 9.36218C16.659 9.32572 16.7922 9.25804 16.906 9.164L21.183 5.5C21.2651 5.43322 21.3663 5.39422 21.472 5.3886C21.5776 5.38299 21.6824 5.41105 21.7711 5.46875C21.8598 5.52645 21.9279 5.61081 21.9657 5.70969C22.0034 5.80857 22.0087 5.91687 21.981 6.019L19.147 16.265C19.0891 16.4747 18.9645 16.6598 18.792 16.7922C18.6195 16.9247 18.4085 16.9973 18.191 16.999H5.81C5.59233 16.9975 5.38111 16.925 5.20839 16.7925C5.03567 16.66 4.91089 16.4748 4.853 16.265L2.02 6.02C1.99225 5.91787 1.99762 5.80957 2.03534 5.71069C2.07306 5.61181 2.14118 5.52745 2.2299 5.46975C2.31862 5.41205 2.42335 5.38399 2.52904 5.3896C2.63472 5.39522 2.73589 5.43422 2.818 5.501L7.094 9.165C7.2078 9.25904 7.341 9.32672 7.48406 9.36318C7.62712 9.39964 7.77647 9.40397 7.9214 9.37586C8.06632 9.34775 8.20323 9.28791 8.32229 9.20062C8.44135 9.11333 8.5396 9.00076 8.61 8.871L11.562 3.266Z",
    fill: "#EEB943",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21H19",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "hand-coins"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 16 6 6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 9,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 5,
    r: 3
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "hard-drive-upload"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 6-4-4-4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2v8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 8,
    x: 2,
    y: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 18h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18h.01"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "hash"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 20,
    y1: 9,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 20,
    y1: 15,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 8,
    y1: 3,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    x2: 14,
    y1: 3,
    y2: 21
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "headset"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 16v2a4 4 0 0 1-4 4h-5"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "heart-handshake"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 15-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 18-2-2"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "history"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3v5h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v5l4 2"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "house"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "id-card"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 10h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17 15a3 3 0 0 1 5.66 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 11,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 20,
    height: 14,
    rx: 2
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "info"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8h.01"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "landmark"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3,
    x2: 21,
    y1: 22,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    x2: 6,
    y1: 18,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 10,
    y1: 18,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    x2: 14,
    y1: 18,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    x2: 18,
    y1: 18,
    y2: 11
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12 2 20 7 4 7"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "layout-grid"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    x: 3,
    y: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    x: 14,
    y: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    x: 14,
    y: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    x: 3,
    y: 14,
    rx: 1
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "list"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 12h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12h13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18h13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6h13"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "mail-open"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "mail"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    x: 2,
    y: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "map-pin-house"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .445-.832l3-2a1 1 0 0 1 1.11 0l3 2A1 1 0 0 1 22 17v4a1 1 0 0 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 .601.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 22v-3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 3
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "map-pin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "megaphone"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3 11 18-5v12L3 14v-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6 16.8a3 3 0 1 1-5.8-1.6"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "menu"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 20,
    y1: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 20,
    y1: 6,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 20,
    y1: 18,
    y2: 18
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "messages-square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "minus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12h14"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "mouse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 2,
    width: 14,
    height: 20,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6v4"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "move-left"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 8L2 12L6 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12H22"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "move-right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 8L22 12L18 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12H22"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "pencil-line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20h9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 5 3 3"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "piggy-bank"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2V5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9v1c0 1.1.9 2 2 2h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11h.01"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "plus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5v14"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "radio"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9 19.1C1 15.2 1 8.8 4.9 4.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1 4.9C23 8.8 23 15.1 19.1 19"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "receipt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.5v-11"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "refresh-cw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 3v5h-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16H3v5"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "save"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3v4a1 1 0 0 0 1 1h7"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "scale"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21h10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "scroll-text"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 12h-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 8h-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 17V5a2 2 0 0 0-2-2H4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "search"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 21-4.3-4.3"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "send"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.854 2.147-10.94 10.939"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "settings"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "shield-check"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 12 2 2 4-4"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "shield-plus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9v6"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "siren"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 18v-6a5 5 0 1 1 10 0v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 4.5 18 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.929 4.929.707.707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v6"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "smartphone"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 20,
    x: 5,
    y: 2,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18h.01"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "square-stack"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 10c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 14,
    y: 14,
    rx: 2
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "sticky-note"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3v4a2 2 0 0 0 2 2h4"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "store"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 7h20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "thumbs-up"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 10v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "ticket"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 5v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 17v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11v2"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "tower-control"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2 12.27 20 6H4l1.8 6.27a1 1 0 0 0 .95.73h10.5a1 1 0 0 0 .96-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13v9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22v-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 6 1 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 6-1 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6V2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 2h-2"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "trash-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 6h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 10,
    y1: 11,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    x2: 14,
    y1: 11,
    y2: 17
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "unlink"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    x2: 8,
    y1: 2,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    x2: 5,
    y1: 8,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    x2: 16,
    y1: 19,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    x2: 22,
    y1: 16,
    y2: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "user-check"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 11 18 13 22 9"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "user-cog"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 15,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15H6a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7 16.4-.9-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.2 13.9-.9-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.6 18.7.3-.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.1 12.2.3-.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.6 18.7-.4-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.8 12.3-.4-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.3 16.6 1-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.7 13.8 1-.4"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "user-plus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    x2: 19,
    y1: 8,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    x2: 16,
    y1: 11,
    y2: 11
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "user-search"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3 15H7a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 21-1.9-1.9"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "user-x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    x2: 22,
    y1: 8,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    x2: 17,
    y1: 8,
    y2: 13
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "users"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 21v-2a4 4 0 0 0-3-3.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3.13a4 4 0 0 1 0 7.75"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "wallet"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "whatsapp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 6 6 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 6 12 12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.8226bfd126f5a9d256f3015b3dd76a30.svg";
export { ForwardRef as ReactComponent };